import { HiringCopilotRequest } from 'libs/end-to-end/src/custom-viz/HiringCopilotTypes';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { useCustomVizBasedLastPersistedRequest } from 'apps/sigma2-ui/src/components/custom-viz/hooks/useCustomVizBasedLastPersistedRequest';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { hiringCopilotCustomVizCacheKey } from 'apps/sigma2-ui/src/constants/usable-cache-keys';

export const useHiringCopilotLastPersistedRequest = ({
  myObservation,
  lastSuccessfulCustomVizRequest,
}: {
  myObservation: MyObservation;
  lastSuccessfulCustomVizRequest: CustomVizRequest | null;
}) =>
  useCustomVizBasedLastPersistedRequest({
    persistKey: hiringCopilotCustomVizCacheKey({
      webCacheKeyPrefix: myObservation.webCacheKeyPrefix,
    }),
    lastSuccessfulCustomVizRequest,
    parseable: HiringCopilotRequest,
  });
